import { Component, OnInit } from "@angular/core";
import { FormArray, Validators, FormBuilder, FormGroup } from "@angular/forms";
import { IApplicantExamination } from "../model/IApplicantExamination";
import { ApplicantService } from "../service/applicant.service";
import { BehaviorModelChangeService } from "../service/behavior-model-change.service.service";
import { CookiesLocalService } from "../service/cookies-local.service";
import { Router } from "@angular/router";
import { UtilService } from "../service/util.service";
import { ToastrService } from "ngx-toastr";
import { IApplicantCourseGradeTypeItem } from "../model/IApplicantCourseGradeTypeItem";
import { IApplicantCourse } from "../model/IApplicantCourse";
import { ISelectionBox } from "../model/ISelectionBox";
import { ComponentBase } from "../base/component-base";
import { IApplicantExaminationItem } from "../model/IApplicantExaminationItem";
import { DialogService } from "../service/dialog-service";

export interface IApplicantExamData {
  ApplicantExaminationItemId?: string;
  ApplicantExaminationId?: string;
  ApplicantCourseId?: string;
  ApplicantCourseGradeTypeItemId?: string;
  ApplicantCourseName?: string;
  Name?: string;
  ApplicantCourseCategoryId?: string;
  ApplicantCourseGradeTypeId?: string;
  ApplicantCourse?: string;
  ApplicantExaminationTypeId?: string;
  Grades?: any[];
}

@Component({
  selector: "app-applicant-examination",
  templateUrl: "./applicant-examination.component.html",
  styleUrls: ["./applicant-examination.component.css"],
})
export class ApplicantExaminationComponent
  extends ComponentBase
  implements OnInit {
  institutions: ISelectionBox[];
  applicationTypes = [];
  examPeriods: ISelectionBox[];
  regions: ISelectionBox[];
  applicationModes: ISelectionBox[];
  yearOfExamSittings = [];
  examinationTypes = [];
  tempApplicantCourses: IApplicantCourse[] = [];
  tempApplicantCourseGradeTypeItems: IApplicantCourseGradeTypeItem[] = [];
  examinationForm: FormGroup;
  examinationData: any[];
  maxiumNumberOfExam: number = 3;
  title = "";
  isShowBaccalaureat: boolean = false;

  leftCourseName = "";
  rightCourseName = "";

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private utilService: UtilService,
    applicantService: ApplicantService,
    cookieLocal: CookiesLocalService,
    private toastr: ToastrService,
    behaviorModelChangeService: BehaviorModelChangeService,
    private dialogService: DialogService
  ) {
    super(applicantService, cookieLocal, behaviorModelChangeService);
  }

  ngOnInit() {
    this.showLoadingIndicator = true;

    //this.title = 'Please enter Institution Attended and Examination information.';
    this.title = "Please  Provide High School Record(s)";

    this.examinationForm = this.fb.group({
      Caption: [""],
      ApplicantExaminations: this.fb.array([]),
    });

    this.getLoadData();

    this.utilService.getApplicantCourses().subscribe((data) => {
      this.tempApplicantCourses = data;
      this.buildApplicantItems();
    });
  }

  buildApplicantItems() {
    const control = <FormArray>(
      this.examinationForm.controls.ApplicantExaminations
    );

    this.utilService.getApplicantCourseGradeTypeItems().subscribe((data) => {
      this.tempApplicantCourseGradeTypeItems = data;

      this.utilService.getApplicantExaminationTypes().subscribe((data) => {
        this.utilService.getApplicationTypes().subscribe((r) => {
          this.applicationTypes = r.filter(
            (a) => a.ApplicationTypeId == this.applicantData.ApplicationTypeId
          );

          this.examinationTypes = data
            .filter(
              (d) =>
                d.IsForignStudent == this.applicationTypes[0].IsForignStudent
            )
            .map((item) => {
              return {
                ValueId: item.ApplicantExaminationTypeId,
                DisplayValue: item.Name.toUpperCase(),
              };
            });

          this.applicantService
            .getApplicantExaminations(this.applicantData.ApplicationId)
            .subscribe((data) => {
              this.examinationData = data;
              data.forEach((item) => {
                control.push(this.InitApplicantExaminations(item));
              });
              this.showLoadingIndicator = false;
            });
        });
      });
    });
  }

  getAddExamButtonName() {
    const control = <FormArray>(
      this.examinationForm.controls.ApplicantExaminations
    );
    const count = control.length;
    if (count > 0) {
      return "Click to provide your exam details (If any)";
    } else {
      return "Click to provide your exam details";
    }
  }

  InitApplicantExaminations(data: IApplicantExamination = null) {
    if (this.isForignStudent()) {
      return this.getExamHeaderForForign(data);
    } else {
      return this.getExamHeaderForLocalStudent(data);
    }
  }

  getExamHeaderForLocalStudent(data) {
    if (data) {
      return this.fb.group({
        ApplicationId: [this.applicantData.ApplicationId],
        ApplicantExaminationId: [data.ApplicantExaminationId],
        ExaminationCentre: [data.ExaminationCentre, Validators.required],
        YearOfExamSitting: [data.YearOfExamSitting, Validators.required],
        ExamIndexNumber: [data.ExamIndexNumber, Validators.required],
        SchoolCode: [data.SchoolCode, Validators.required],
        ExamPeriodId: [data.ExamPeriodId, Validators.required],
        RegionId: [data.RegionId, Validators.required],
        ApplicationModeId: [data.ApplicationModeId, Validators.required],
        InstitutionId: [data.InstitutionId, Validators.required],
        ApplicantExaminationTypeId: [
          data.ApplicantExaminationTypeId,
          Validators.required,
        ],
        InstitutionName: [data.InstitutionName],
        ApplicantExaminationItems: this.fb.array([
          this.InitApplicantExaminationItems(
            data.ApplicantExaminationTypeId,
            data.ApplicantExaminationId
          ),
        ]),
      });
    }
    return this.fb.group({
      ApplicationId: [this.applicantData.ApplicationId],
      ApplicantExaminationId: [0],
      ExaminationCentre: [" ", Validators.required],
      YearOfExamSitting: ["", Validators.required],
      ExamIndexNumber: ["", Validators.required],
      SchoolCode: ["", Validators.required],
      ExamPeriodId: ["", Validators.required],
      RegionId: ["", Validators.required],
      ApplicationModeId: ["", Validators.required],
      InstitutionId: ["", Validators.required],
      ApplicantExaminationTypeId: ["", Validators.required],
      InstitutionName: [""],
      ApplicantExaminationItems: this.fb.array([]),
    });
  }

  getExamHeaderForForign(data) {
    if (data) {
      const appExam = this.fb.group({
        ApplicationId: [this.applicantData.ApplicationId],
        ApplicantExaminationId: [data.ApplicantExaminationId],
        ExaminationCentre: [data.ExaminationCentre],
        YearOfExamSitting: [data.YearOfExamSitting, Validators.required],
        ExamIndexNumber: [data.ExamIndexNumber],
        SchoolCode: [data.SchoolCode],
        ExamPeriodId: [data.ExamPeriodId],
        RegionId: [data.RegionId],
        ApplicationModeId: [data.ApplicationModeId],
        InstitutionId: [data.InstitutionId],
        ApplicantExaminationTypeId: [data.ApplicantExaminationTypeId],
        InstitutionName: [data.InstitutionName, Validators.required],
        ApplicantExaminationItems: this.fb.array([
          this.InitApplicantExaminationItems(
            data.ApplicantExaminationTypeId,
            data.ApplicantExaminationId
          ),
        ]),
      });

      return appExam;
    }

    const appExam = this.fb.group({
      ApplicationId: [this.applicantData.ApplicationId],
      ApplicantExaminationId: [0],
      ExaminationCentre: [" "],
      YearOfExamSitting: ["", Validators.required],
      ExamIndexNumber: [""],
      SchoolCode: [""],
      ExamPeriodId: [""],
      RegionId: [""],
      ApplicationModeId: [""],
      InstitutionId: [""],
      ApplicantExaminationTypeId: [""],
      InstitutionName: ["", Validators.required],
      ApplicantExaminationItems: this.fb.array([]),
    });

    return appExam;
  }

  InitApplicantExaminationItems(
    applicantExaminationTypeId: number,
    applicantExaminationId: number
  ) {
    const userApplicantExaminations = this.examinationData.filter(
      (x) =>
        x.ApplicantExaminationTypeId == applicantExaminationTypeId &&
        x.ApplicantExaminationId == applicantExaminationId
    );

    const allApplicationCourses = this.tempApplicantCourses.map((d) => {
      const data: IApplicantExamData = {
        ApplicantExaminationItemId: "",
        ApplicantExaminationId: "",
        ApplicantCourseId: d.ApplicantCourseId.toString(),
        ApplicantCourseGradeTypeItemId: "",
        ApplicantCourseName: "",
        Name: d.ApplicantCourse,
        ApplicantCourseCategoryId: d.ApplicantCourseCategoryId.toString(),
        ApplicantCourseGradeTypeId: d.ApplicantCourseGradeTypeId.toString(),
        ApplicantCourse: d.ApplicantCourse,
        ApplicantExaminationTypeId: d.ApplicantCourseGradeTypeId.toString(),
        Grades: [],
      };

      return data;
    });

    if (userApplicantExaminations[0]) {
      const userApplicantExaminationItems: IApplicantExaminationItem[] =
        userApplicantExaminations[0].ApplicantExaminationItems;

      if (userApplicantExaminationItems.length > 0) {
        userApplicantExaminationItems.forEach((element) => {
          const selectedItem = allApplicationCourses.filter(
            (x) => x.ApplicantCourseId == element.ApplicantCourseId.toString()
          );

          if (selectedItem.length > 0) {
            const selectedIdex = allApplicationCourses.indexOf(selectedItem[0]);

            allApplicationCourses[
              selectedIdex
            ].ApplicantExaminationId = this.checkForNull(
              element.ApplicantExaminationId
            );
            allApplicationCourses[
              selectedIdex
            ].ApplicantExaminationItemId = this.checkForNull(
              element.ApplicantExaminationItemId
            );
            allApplicationCourses[
              selectedIdex
            ].ApplicantCourseGradeTypeItemId = this.checkForNull(
              element.ApplicantCourseGradeTypeItemId
            );
            allApplicationCourses[
              selectedIdex
            ].ApplicantCourseName = this.checkForNull(
              element.ApplicantCourseName
            );
          }
        });
      }
    }

    const applicantCoreCourses = [];
    const applicantElectiveCourses = [];
    const applicantOtherCourses = [];

    const applicantCourseGradeTypeItems = this.tempApplicantCourseGradeTypeItems.filter(
      (item) => item.ApplicantCourseGradeTypeId == applicantExaminationTypeId
    );

    allApplicationCourses
      .filter(
        (item) =>
          item.ApplicantExaminationTypeId ==
          applicantExaminationTypeId.toString()
      )
      .forEach((e) => {
        e.Grades = applicantCourseGradeTypeItems;
        const id = parseInt(e.ApplicantCourseCategoryId);
        if (id === 1 || id === 4) {
          if (id === 4)
            this.rightCourseName = "ADVANCED LEVEL (A LEVEL) SUBJECTS";
          else this.rightCourseName = "CORE SUBJECTS";

          applicantCoreCourses.push(e);
        } else if (id === 2 || id === 5) {
          if (id === 5)
            this.leftCourseName = "ORDINARY LEVEL (O LEVEL) SUBJECTS";
          else this.leftCourseName = "ELECTIVE SUBJECTS";

          applicantElectiveCourses.push(e);
        } else if (id === 3 || !e.Name || e.Name == "#") {
          applicantOtherCourses.push(e);
        }
      });

    const coreForm = this.InitApplicantExaminationSubItems(
      applicantCoreCourses
    );
    const elecForm = this.InitApplicantExaminationSubItems(
      applicantElectiveCourses
    );
    const otherForm = this.InitApplicantExaminationSubItems(
      applicantOtherCourses
    );

    return this.fb.group({
      CoreSubjects: this.fb.array(coreForm),
      ElectiveSubjects: this.fb.array(elecForm),
      OptionalSubjects: this.fb.array(otherForm),
    });
  }

  checkForNull(val) {
    if (val || val == 0) {
      return val.toString();
    }
    return "";
  }

  InitApplicantExaminationSubItems(items) {
    const arr = [];
    items.forEach((element) => {
      arr.push(
        this.fb.group({
          ApplicantExaminationItemId: [element.ApplicantExaminationItemId],
          ApplicantExaminationId: [element.ApplicantExaminationId],
          ApplicantCourseId: [element.ApplicantCourseId],
          ApplicantCourseGradeTypeItemId: [
            element.ApplicantCourseGradeTypeItemId,
          ],
          ApplicantCourseName: [element.ApplicantCourseName],
          Name: [element.Name],
          Grades: this.fb.array(
            this.InitApplicantExaminationItemGrade(element.Grades)
          ),
        })
      );
    });

    return arr;
  }

  InitApplicantExaminationItemGrade(data) {
    const arr = [];
    data.forEach((element) => {
      arr.push(
        this.fb.group({
          ApplicantCourseGradeTypeItemId: [
            this.checkForNull(element.ApplicantCourseGradeTypeItemId),
          ],
          ApplicantCourseGradeTypeItem: [
            this.checkForNull(element.ApplicantCourseGradeTypeItem),
          ],
          ApplicantCourseGradeType: [
            this.checkForNull(element.ApplicantCourseGradeType),
          ],
          ApplicantCourseGradeTypeId: [
            this.checkForNull(element.ApplicantCourseGradeTypeId),
          ],
        })
      );
    });
    return arr;
  }

  getLoadData() {
    this.utilService.getRegions().subscribe((data) => {
      this.regions = data.map((item) => {
        return {
          ValueId: item.ValueId,
          DisplayValue: item.DisplayValue.toUpperCase(),
        };
      });
    });

    this.utilService.getApplicationModes().subscribe((data) => {
      this.applicationModes = data.map((item) => {
        return {
          ValueId: item.ValueId,
          DisplayValue: item.DisplayValue.toUpperCase(),
        };
      });
    });

    this.utilService.getExamPeriods().subscribe((data) => {
      this.examPeriods = data.map((item) => {
        return {
          ValueId: item.ValueId,
          DisplayValue: item.DisplayValue.toUpperCase(),
        };
      });
    });

    this.utilService.getInstitutions().subscribe((data) => {
      this.institutions = data.map((item) => {
        return {
          ValueId: item.ValueId,
          DisplayValue: item.DisplayValue.toUpperCase(),
        };
      });
    });
    this.utilService.getYears().subscribe((data) => {
      this.yearOfExamSittings = data;
    });
  }

  onSelectApplicantExaminationTypeId(appExam, index) {
    const applicantExaminationTypeId =
      appExam.controls.ApplicantExaminationTypeId.value;
    const applicantExaminationId = appExam.value.ApplicantExaminationId;

    this.isShowBaccalaureat =
      applicantExaminationTypeId >= 7 && this.isForignStudent();
    const ctl = <FormArray>this.examinationForm.get("ApplicantExaminations");
    const control = <FormArray>(
      ctl.controls[index].get("ApplicantExaminationItems")
    );
    control.removeAt(0);
    control.push(
      this.InitApplicantExaminationItems(
        applicantExaminationTypeId,
        applicantExaminationId
      )
    );
  }

  save(form: any): boolean {
    if (!form.valid) {
      return false;
    }

    return true;
  }

  goToNext(form: any) {
    this.router.navigate(["/applicant/info/programme-selection"]);
  }

  goToPrevious(form: any) {
    this.router.navigate(["/applicant/info/personal/guardian"]);
  }

  onAddExaminationClick(): void {
    const control = <FormArray>(
      this.examinationForm.controls.ApplicantExaminations
    );
    const currentNumberOfExam = control.controls.length;

    if (currentNumberOfExam >= this.maxiumNumberOfExam) {
      this.toastr.warning(
        "Sorry you can only apply with three(3) examinations"
      );
    } else {
      control.push(this.InitApplicantExaminations());
    }
  }

  onRemoveExaminationClick(index): void {
    const data = (<FormArray>(
      this.examinationForm.get("ApplicantExaminations")
    )).at(index).value;
    if (data.ApplicantExaminationId > 0) {
      this.dialogService
        .openConfirmDialog("Are you sure you want to delete examination?")
        .afterClosed()
        .subscribe((d) => {
          this.applicantService
            .removeApplicantExamination(data.ApplicantExaminationId)
            .subscribe(
              (data) => {
                (<FormArray>(
                  this.examinationForm.get("ApplicantExaminations")
                )).removeAt(index);
                this.toastr.success("Exam histroy removed successfully");
              },
              (error) => {
                console.log(error);
              }
            );
        });
    } else {
      (<FormArray>this.examinationForm.get("ApplicantExaminations")).removeAt(
        index
      );
    }
  }

  onSaveExaminationClick(item, index) {
    this.showLoadingIndicator = true;

    let model: IApplicantExamination;
    model = item.value;

    let canSaved = true;

    const finalItems = [];
    let coreItems = [];
    let eletiveItems = [];
    let optItems = [];

    if (item.value.ApplicantExaminationItems.length == 0) {
      this.toastr.warning("Exam Record result not filled");
      return;
    }
    const eMainItems = item.value.ApplicantExaminationItems[0];

    if (this.isShowBaccalaureat) {
      model.ApplicantExaminationItems = [];
      this.applicantService.saveApplicantExamination(model).subscribe(
        (data) => {
          (<FormArray>this.examinationForm.get("ApplicantExaminations")).at(
            index
          ).value.ApplicantExaminationId = data.Id;
          this.showLoadingIndicator = false;
          this.toastr.success("Exam Record has been updated");

          return;
        },
        (error) => {
          console.log(error);
        }
      );
    } else if (model.ApplicantExaminationTypeId == 4) {
      //
      model.ApplicantExaminationItems = [];
      this.applicantService.saveApplicantExamination(model).subscribe(
        (data) => {
          (<FormArray>this.examinationForm.get("ApplicantExaminations")).at(
            index
          ).value.ApplicantExaminationId = data.Id;
          this.showLoadingIndicator = false;
          this.toastr.success("Exam Record has been updated");

          return;
        },
        (error) => {
          console.log(error);
          return;
        }
      );
    } else {
      if (!eMainItems) {
        return;
      }

      coreItems = eMainItems.CoreSubjects;
      eletiveItems = eMainItems.ElectiveSubjects;
      optItems = eMainItems.OptionalSubjects;

      if (coreItems) {
        coreItems.forEach((element) => {
          finalItems.push(element);
        });
      }
      if (eletiveItems) {
        eletiveItems.forEach((element) => {
          finalItems.push(element);
        });
      }
      if (optItems) {
        optItems.forEach((element) => {
          if (element.Name && element.ApplicantCourseGradeTypeItemId > 0) {
            canSaved = false;
          }
          finalItems.push(element);
        });
      }
      if (finalItems.length > 0) {
        model.ApplicantExaminationItems = finalItems;
      } else {
        this.toastr.info("No changes made");
      }

      if (canSaved) {
        if (finalItems.length > 0) {
          this.applicantService.saveApplicantExamination(model).subscribe(
            (data) => {
              const control = (<FormArray>(
                this.examinationForm.get("ApplicantExaminations")
              )).at(index);
              control["controls"].ApplicantExaminationId.setValue(data.Id);
              this.showLoadingIndicator = false;

              this.toastr.success("Exam Record has been updated");
            },
            (error) => {
              console.log(error);
            }
          );
        }
      } else {
        this.toastr.warning("Please enter name for optional courses");
      }
    }
  }

  isHideSubTitleShow(appExam) {
    const id = appExam.controls.ApplicantExaminationTypeId.value;
    return (
      !this.isForignStudent() &&
      !(id == 4 && !this.applicantData.IsForignStudent)
    );
  }

  isFormValid() {
    const ctl = <FormArray>this.examinationForm.get("ApplicantExaminations");
    return (
      (this.examinationForm.valid && ctl.length > 0) ||
      this.isCertificateStudent()
    );
  }

  getApplicantExaminationItems(form) {
    return form.controls.ApplicantExaminationItems.controls;
  }

  getApplicantElectiveCourses(form) {
    return form.controls.ElectiveSubjects.controls;
  }
  getApplicantCoreCourses(form) {
    return form.controls.CoreSubjects.controls;
  }

  getApplicantOptionalCourses(form) {
    return form.controls.OptionalSubjects.controls;
  }

  getApplicantExaminationArray(form) {
    return form.controls.ApplicantExaminations.controls;
  }
}
